import { Group, Stack, Text } from "@mantine/core"
import {
  CommunicationStudioClasses,
  CUSTOMISATION_CATEGORIES,
} from "@tfg/types/constants/communication-studio.constant"
import { AGECResponses } from "@tfg/types/endpoints/agec"
import { FooterComponentCustomisationConfiguration } from "@tfg/types/schemas/communication-studio/configurationParameters"
import { textColorCssVariable } from "@tfg/types/schemas/communication-studio/cssVariables"

import { IconLogo } from "../../icons/logos/IconLogo"
import { TrimanLogo } from "../../icons/logos/TrimanLogo"

import { useGetStylingParametersContext } from "./context/stylingParameters/useGetStylingParametersContext"
import { useGetTranslationsContext } from "./context/translationsContext/useGetTranslationsContext"
import { DesignStudioParametersToolkit } from "./utils/designStudioParametersToolkit"

type Props = {
  agecData: AGECResponses.GenericAgecData
} & FooterComponentCustomisationConfiguration

export function FooterAGEC({
  agecData,
  showPoweredByTFG,
  showLastUpdateTimestamp,
}: Props) {
  const { t } = useGetTranslationsContext()
  const { stylingParameters } = useGetStylingParametersContext()
  if (!stylingParameters) {
    return null
  }
  return (
    <Stack
      w="100%"
      style={DesignStudioParametersToolkit.spreadStylingParameters({
        category: CUSTOMISATION_CATEGORIES.FOOTER,
        stylingParameters,
        stylingParamKeys: ["marginBottom", "marginTop"],
      })}
    >
      <Stack justify="center" align="center" gap={0}>
        {showLastUpdateTimestamp && (
          <p
            className={CommunicationStudioClasses.LAST_UPDATE}
            style={{
              color:
                DesignStudioParametersToolkit.getCssVariableLiteralName(
                  textColorCssVariable
                ),
            }}
          >
            {t("lastUpdate")}
            {agecData.lastUpdate}
          </p>
        )}
        <Stack align="center" gap={0}>
          <TrimanLogo />
          {showPoweredByTFG && <PoweredBy />}
        </Stack>
      </Stack>
    </Stack>
  )
}

export const PoweredBy = () => (
  <Group wrap="nowrap" gap={0} align="center" justify="center">
    <Text
      span
      mr={4}
      fw="bold"
      c={DesignStudioParametersToolkit.getCssVariableLiteralName(
        textColorCssVariable
      )}
    >
      Powered by
    </Text>{" "}
    <a
      href="https://www.traceforgood.com"
      target="_blank"
      rel="noopener noreferrer"
    >
      <IconLogo height={24} />
    </a>
  </Group>
)
